import { render, staticRenderFns } from "./JockeyStatistics.vue?vue&type=template&id=cf4624ec&scoped=true"
import script from "./JockeyStatistics.vue?vue&type=script&lang=js"
export * from "./JockeyStatistics.vue?vue&type=script&lang=js"
import style0 from "./JockeyStatistics.vue?vue&type=style&index=0&id=cf4624ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf4624ec",
  null
  
)

export default component.exports